import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var UsuariosService = /** @class */ (function () {
    function UsuariosService(http) {
        this.http = http;
        this.baseUrl = environment.baseUrl;
    }
    // Guarda las configuraciones del usuario
    UsuariosService.prototype.postUsuariosNotificaciones = function (celular) {
        return this.http
            .post(this.baseUrl + '/usuario/', {
            _celular: celular
        })
            .pipe(map(function (user) {
            // login successful if there's a jwt token in the response
            if (user && user.username) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('currentUser', JSON.stringify(user));
            }
            return user;
        }));
    };
    UsuariosService.prototype.getCurrentUserInfo = function () {
        return this.http.get(this.baseUrl + '/usuarios').pipe(map(function (user) {
            return user;
        }));
    };
    UsuariosService.prototype.registrar = function (user) {
        return this.http.post(this.baseUrl + '/usuarios', user);
    };
    UsuariosService.prototype.editarUsuario = function (user) {
        return this.http.put(this.baseUrl + '/editar-usuarios', user);
    };
    UsuariosService.prototype.getUsuarioSuscripciones = function () {
        return this.http.get(this.baseUrl + '/usuarios-suscripciones');
    };
    UsuariosService.prototype.deleteUsuarioSuscripcion = function (id) {
        return this.http.delete(this.baseUrl + '/usuarios-suscripciones/' + id);
    };
    UsuariosService.ngInjectableDef = i0.defineInjectable({ factory: function UsuariosService_Factory() { return new UsuariosService(i0.inject(i1.HttpClient)); }, token: UsuariosService, providedIn: "root" });
    return UsuariosService;
}());
export { UsuariosService };
